import { Outlet } from 'react-router-dom';
import { useCallback } from 'react';
import { useIdleTimer, workerTimers } from 'react-idle-timer';

import { ROUTES } from '../../routes';
import { useSearchNavigate } from '../../hooks/useSearchNavigate';

export const IdleCountdown = ({
  route,
  msTimeout,
  disabled,
}: {
  route?: typeof ROUTES[keyof typeof ROUTES];
  msTimeout: number;
  disabled?: boolean;
}) => {
  const navigate = useSearchNavigate();
  const goToRoute = useCallback(() => navigate(route || ROUTES.Home), [navigate]);

  useIdleTimer({
    timeout: msTimeout,
    onIdle: goToRoute,
    timers: workerTimers,
    startOnMount: true,
    startManually: process.env.REACT_APP_ENVIRONMENT === 'develop' || disabled,
  });

  return <Outlet />;
};
